import { render, staticRenderFns } from "./TraceabilityAscContainer.vue?vue&type=template&id=01b837bc"
import script from "./TraceabilityAscContainer.vue?vue&type=script&lang=js"
export * from "./TraceabilityAscContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports